import { Component, Input} from '@angular/core';

@Component({
  selector: 'app-header-div',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() logoUrl: string;
  @Input() contactNumber: string;
}
